'use client';

import { I18nextProvider } from 'react-i18next';

import { i18n } from './client';

type I18nextProviderWrapperProps = {
  children: React.ReactNode;
};

const I18nextProviderWrapper = ({ children }: I18nextProviderWrapperProps) => (
  <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
);

export { I18nextProviderWrapper };
